import { useTranslation } from 'react-i18next';
import type { Control, FieldErrors } from 'react-hook-form';
import { Input } from '@/components/ui/input';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from '@/components/ui/form';

interface PersonNameFieldsProps {
  // eslint_disable-next-line @typescript-eslint/no-explicit-any
  control: Control<any>;
  // eslint_disable-next-line @typescript-eslint/no-explicit-any
  errors: FieldErrors<any>;
}

export function PersonNameFields({ control, errors }: PersonNameFieldsProps) {
  const { t } = useTranslation();

  return (
    <div className="flex gap-2.5">
      <FormField
        control={control}
        name="lastname"
        render={({ field }) => (
          <FormItem className="w-full">
            <FormLabel>
              {t('lastName')} <span className="text-red-500">*</span>
            </FormLabel>
            <FormControl>
              <Input
                {...field}
                className={errors.lastname ? 'border-red-500' : 'border-input'}
              />
            </FormControl>
          </FormItem>
        )}
      />
      <FormField
        control={control}
        name="name"
        render={({ field }) => (
          <FormItem className="w-full">
            <FormLabel>
              {t('firstName')} <span className="text-red-500">*</span>
            </FormLabel>
            <FormControl>
              <Input
                {...field}
                className={errors.name ? 'border-red-500' : 'border-input'}
              />
            </FormControl>
          </FormItem>
        )}
      />
      <FormField
        control={control}
        name="middlename"
        render={({ field }) => (
          <FormItem className="w-full">
            <FormLabel>{t('middleName')}</FormLabel>
            <FormControl>
              <Input {...field} />
            </FormControl>
          </FormItem>
        )}
      />
    </div>
  );
}
